import { Types as FileOperationTypes } from "../../../../_types/FileOperationTypes";

export const ActionCreators: any = {
  uploadFileToPermanentFolder: (data: any) => ({
    types: [FileOperationTypes.FILE_OPERATION_REQUESTED,FileOperationTypes.FILE_PERMANENT_UPLOAD_SUCCESS,FileOperationTypes.FILE_OPERATION_FAILURE],
    promise: (client: any) => client.post("upload_file_to_permanent_folder", { data }, "admin_backend")
  }),
}

export default ActionCreators;